import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["loading"]
const _hoisted_2 = ["value", "type", "placeholder", "disabled"]
const _hoisted_3 = {
  key: 0,
  class: "bs-textarea__validation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-textarea", {
            'bs-textarea--medium': _ctx.size === 'medium',
            'bs-textarea--big': _ctx.size === 'big',
            'bs-textarea--disabled': _ctx.disabled,
            'bs-textarea--invalid': _ctx.invalid
        }]),
    loading: _ctx.loading
  }, [
    _createElementVNode("textarea", {
      class: "bs-textarea__control",
      value: _ctx.modelValue,
      type: _ctx.type,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled || _ctx.loading,
      rows: 4,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
    }, null, 40, _hoisted_2),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}